export const getIsPremiumApp = appForInstallation => {
  var _appForInstallation$a;
  return (appForInstallation == null || (_appForInstallation$a = appForInstallation.app) == null || (_appForInstallation$a = _appForInstallation$a.data) == null || (_appForInstallation$a = _appForInstallation$a.pricingModels) == null || (_appForInstallation$a = _appForInstallation$a[0]) == null ? void 0 : _appForInstallation$a.isRequiredWixPremium) || false;
};
export const getOauthOpenMethod = appForInstallation => {
  var _appForInstallation$a2;
  return (appForInstallation == null || (_appForInstallation$a2 = appForInstallation.app) == null || (_appForInstallation$a2 = _appForInstallation$a2.authData) == null ? void 0 : _appForInstallation$a2.openConsentIn) || null;
};
export const getVersionToInstall = (appForInstallation, version) => version === 'dev' ? 'dev' : appForInstallation == null ? void 0 : appForInstallation.versionToInstall;
export const getAppMarketPermissions = appForInstallation => {
  var _appForInstallation$a3;
  return (appForInstallation == null || (_appForInstallation$a3 = appForInstallation.app) == null || (_appForInstallation$a3 = _appForInstallation$a3.data) == null || (_appForInstallation$a3 = _appForInstallation$a3.permissions) == null ? void 0 : _appForInstallation$a3.map(_ref => {
    let {
      permissionId
    } = _ref;
    return permissionId || '';
  })) || [];
};
//# sourceMappingURL=appForInstallation.js.map